import { ToggleButton } from 'vue-js-toggle-button';

if($('#component-response-status').length){
    var app = new Vue({
        el: '#component-response-status',
        data: {
            oldResponseStatus: response_status_id,
            response_status_id: response_status_id,
            customMessage: null,
            sendEmail: false,
            networkId: networkId,
            applicationId: applicationId,
            applicationType: applicationType,
            showModal: false,
            status: null
        },
        methods: {
            changeResponseStatus(){
        
                var data = {
                    responseId: this.response_status_id,
                    sendEmail: this.sendEmail,
                    customMessage: this.customMessage
                }
    
                axios.patch('/api/v1/network/'+this.networkId+'/'+this.applicationType+'/response-status/'+this.applicationId+'/'+this.response_status_id , data).then((response) => {
                    this.sendEmail = false;
                    this.customMessage = null;
                    this.oldResponseStatus = data.responseId;
                    this.$toasted.success('Application response status has been updated');
                    this.showModal = false;
                    this.response()
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            close(){
                var oldResponseStatus = this.oldResponseStatus;
                this.sendEmail = false;
                this.customMessage = null;
                this.response_status_id = oldResponseStatus;
                this.showModal = false;
                this.response()
            },
            errorHandler(error){
                if(error.response && typeof error.response.data === 'string'){
                    this.$toasted.error(error.response.data);
                }else{
                    this.$toasted.error(error.response.data.message);
                }
            },
            response() {
                if (this.response_status_id) {
                    if (this.response_status_id == 3) {
                        this.status = 'interested';
                    } else if (this.response_status_id == 2) {
                        this.status = 'unsure';
                    } else {
                        this.status = 'not-interested';
                    }
                }
            }
        },
        mounted() {
            this.response()
        },
        components: {
            'ToggleButton': ToggleButton
        }
    });
}